/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_Cta_Create_ProtocolInputs */

const cs_templates_empty_cta_create_protocol = /** @type {(inputs: Templates_Empty_Cta_Create_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit šablonu protokolu`)
};

const en_templates_empty_cta_create_protocol = /** @type {(inputs: Templates_Empty_Cta_Create_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create protocol template`)
};

/**
* | output |
* | --- |
* | "Create protocol template" |
*
* @param {Templates_Empty_Cta_Create_ProtocolInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_cta_create_protocol = /** @type {((inputs?: Templates_Empty_Cta_Create_ProtocolInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_Cta_Create_ProtocolInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_cta_create_protocol(inputs)
	return cs_templates_empty_cta_create_protocol(inputs)
});